// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import '../css/index.css';

// Import JS
import menuOpen from './menuOpen';
import infiniteScroll from './infiniteScroll';
import syncFooterYear from './syncFooterYear';
import initThemePreference from './themePreference';

// Call the menu, theme, and infinite scroll functions
initThemePreference();
menuOpen();
syncFooterYear();
infiniteScroll();
